import Button from "@components/Button";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { useManager } from "@src/contexts/WarsContext";
import { images } from "@utils/media";

const LaunchPopup = ({ closePopup }: { closePopup: () => void }) => {
  const manager = useManager();

  const onboardPlayer = async () => {
    closePopup();
    await manager.onboardPlayer();
  };

  return (
    <View className="w-screen h-dvh absolute top-0 left-0 z-[999999] font-[Slackey]">
      <View
        enableEventCapturing
        className="w-full h-full absolute top-0 left-0 bg-black/60"
      />
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex items-center justify-center">
          <View
            enableEventCapturing
            className="relative bg-[#F72EC5] w-[40rem] p-1.5 rounded-xl flex flex-col items-center"
          >
            <h1
              className="text-white mt-0.5 mb-2"
              style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
            >
              Welcome to The Last Show!
            </h1>
            <View className="w-full h-80 bg-gradient-to-t from-[#3355FF] to-[#5B7CFF] rounded-b-xl overflow-hidden">
              <View
                className="w-full h-full bg-cover bg-no-repeat flex flex-col items-center justify-center gap-4"
                style={{ backgroundImage: `url(${images.TilesBackground})` }}
              >
                <View
                  className="w-full h-52 flex flex-col items-center justify-center text-center text-white leading-none px-12"
                  style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
                >
                  <h1>
                    You are now part of an exclusive early release of a new
                    Discord game.
                  </h1>
                </View>
                <View className="flex justify-center">
                  <View
                    enableEventCapturing
                    style={{ backgroundImage: `url(${images.PopupButton})` }}
                    className="w-96 h-14 bg-contain bg-no-repeat"
                  >
                    <Button
                      onClick={onboardPlayer}
                      className="flex items-center justify-center bg-transparent border-none outline-none w-96 h-14 font-[Slackey] text-2xl"
                    >
                      <span>Lets Go!</span>
                    </Button>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default LaunchPopup;
